export const ONBOARDING_APIS = {
  LOGIN: "auth/admin/signin",
  FORGOT_PASSWORD: "auth/admin/forgot-password",
  RESET_PASSWORD: "auth/admin/reset-password",
  GET_PROFILE_DATA: "auth/admin/get-personal-details",
  // REFRESH_TOKEN: '/admin/auth/refresh-token',
  CHANGE_PASSWORD: 'auth/admin/change-password',
};

//Manage vendor Routes
export const MANAGE_VENDOR = {
  CREATE_VENDER: "api/vendor/create",
  EDIT_VENDER: "api/vendor/edit",
  UPDATE_STATUS: "api/vendor/update-status",
  GET_ALL_BUSINESS_CATEGORIES: "api/vendor/business-categories",
  GET_ALL_DropZones: "api/vendor/dropzones",
  GET_ALL_VENDORS: "api/vendor/list",
  GET_VENDOR_DETAIL: "api/vendor/details",
  VENDOR_SETTINGS: "api/vendor/setting",
  //BRANCH
  GET_ALL_BRANCH: "api/branch/list",
  ADD_BRANCH: "api/branch/create",
  EDIT_BRANCH: "api/branch/edit",
  UPDATE_BRANCH_STATUS: "api/branch/update-status",
  BRANCH_DETAIL: "api/branch/detail",

  BRANCH_HOLIDAY_LIST: "api/branch/holiday-list",
  BRANCH_TIMESLOT_LIST: "api/branch/time-slot-list",
  ADD_BRANCH_TIMESLOT: "api/branch/select-time-slot",

  BRANCH_DROPZONE_LIST: "api/branch/branch-dropzone-list",
  UPDATE_BRANCH_DROPZONE_STATUS: "api/branch/update-branch-dropzone-status",
  DELETE_BRANCH_DROPZONE: "api/branch/delete-branch-dropzone",
  DROPZONE_LIST: "api/branch/all-dropzone-list",
  ASSOCIATE_DROPZONE_WITH_BRANCH: "api/branch/associate-dropzone-with-branch",
  ADD_AMOUNT_IN_WALLET: "api/vendor/add-amount-in-wallet",
  GET_WALLET_BALANCE: "api/vendor/get-wallet-balance",
  GET_WALLET_BALANCE_HISTORY: "api/vendor/get-wallet-balance-history",
};

//Manage Canned Seller Routes
export const MANAGE_CANNED_SELLER = {
  CREATE_CANNED_SELLER: "api/canned-seller/create",
  EDIT_CANNED_SELLER: "api/canned-seller/edit",
  UPDATE_STATUS: "api/canned-seller/update-status",
  GET_ALL_CANNED_SELLERS: "api/canned-seller/list",
  GET_CANNED_SELLER_DETAIL: "api/canned-seller/details",
};

//Manage QC Routes
export const MANAGE_QC = {
  GET_ALL_QC: "api/qc/list",
  GET_ALL_BUSINESS_CATEGORIES: "api/vendor/business-categories",
  UPDATE_STATUS: "api/qc/update-status",
  CREATE_QC: "api/qc/create",
  EDIT_QC: "api/qc/edit",
  GET_QC_DETAIL: "api/qc/detail",
};

//Manage Drivers Routes
export const MANAGE_DRIVERS = {
  GET_ALL_DRIVERS: "api/driver/list",
  UPDATE_STATUS: "api/driver/update-status",
  GET_ALL_ZONES: "api/driver/zone-list",
  GET_ALL_VEHICLE: "api/driver/vehicle-list",
  CREATE_DRIVERS: "api/driver/create",
  EDIT_DRIVERS: "api/driver/edit",
  GET_DRIVERS_DETAIL: "api/driver/detail",
};

//Manage Drivers Payout Routes
export const MANAGE_DRIVERS_PAYOUT = {
  GET_ALL_DRIVERS_PAYOUT: "api/driver-payout/list",
  GET_DRIVERS_PAYOUT_DETAIL: "api/driver-payout/detail",
  PAYOUT_MARK_SETTLED: "api/driver-payout/mark-settled",
  EXPORT_ALL_DRIVERS_PAYOUT: "api/driver-payout/export-list",
};

//Manage Vednor Payout Routes
export const MANAGE_VENDOR_PAYOUT = {
  GET_ALL_VENDOR_PAYOUT: "api/vendor-payout/list",
  GET_VENDOR_PAYOUT_DETAIL: "api/vendor-payout/detail",
  PAYOUT_MARK_SETTLED: "api/vendor-payout/mark-settled",
  EXPORT_ALL_VENDOR_PAYOUT: "api/vendor-payout/export-list",
};

export const MANAGE_BUSINESS_CATEGORIES = {
  GET_ALL_BUSINESS_CATEGORIES: "api/business-category/list",
  CREATE_BUSINESS_CATEGORIES: "api/business-category/create",
  UPDATE_STATUS: "api/business-category/update-status",
  EDIT_BUSINESS_CATEGORIES: "api/business-category/edit",
};

export const MANAGE_ITEM_SENSITIVITY = {
  GET_ALL_ITEM_SENSITIVITY: "api/item-sensitivity/list",
  CREATE_ITEM_SENSITIVITY: "api/item-sensitivity/create",
  UPDATE_STATUS: "api/item-sensitivity/update-status",
  EDIT_ITEM_SENSITIVITY: "api/item-sensitivity/edit",
};
//Manage vehicle type Routes
export const MANAGE_VEHICLE_TYPE = {
  CREATE_VEHICLE_TYPE: "api/vehicle-type/create",
  EDIT_VEHICLE_TYPE: "api/vehicle-type/edit",
  UPDATE_STATUS: "api/vehicle-type/update-status",
  GET_ALL_VEHICLE_TYPE: "api/vehicle-type/list",
  GET_VEHICLE_TYPE_DETAIL: "api/vehicle-type/detail",
};

export const MANAGE_PACKAGING_TYPE = {
  CREATE: "api/packaging-type/create",
  EDIT: "api/packaging-type/edit",
  UPDATE: "api/packaging-type/update-status",
  GET: "api/packaging-type/list",
  GET_DETAIL: "api/packaging-type/detail",
};

//Manage Dropzones Routes
export const MANAGE_DROPZONE = {
  CREATE: "api/dropzone/create",
  EDIT: "api/dropzone/edit",
  UPDATE: "api/dropzone/update-status",
  GET: "api/dropzone/list",
  GET_DETAIL: "api/dropzone/detail",
  GET_BRANCH_LIST: "api/dropzone/branch-list",

  GET_DROPZONE_HOLIDAY: "api/dropzone/holiday-list",
  GET_DROPZONE_TIMESLOT_LIST: "api/dropzone/time-slot-list",
  ADD_DROPZONE_TIMESLOT: "api/dropzone/select-time-slot",
};

//Manage Canned Vending Machine Routes
export const MANAGE_CANNED_VENDING_MACHINE = {
  CREATE: "api/canned-machine/create",
  EDIT: "api/canned-machine/edit",
  UPDATE: "api/canned-machine/update-status",
  GET: "api/canned-machine/list",
  GET_DETAIL: "api/canned-machine/detail",
  GET_SELLER_LIST: "api/canned-seller/list",
};

//Manage Zones Routes
export const MANAGE_ZONE = {
  GET_ALL_ZONES: "api/zone/list",
  GET_ZONE_DETAIL: "api/zone/detail",
  UPDATE_STATUS: "api/zone/update-status",
  CREATE_ZONE: "api/zone/create",
  EDIT_ZONE: "api/zone/edit",
  DELETE_ZONE: "api/zone/delete",
  UPDATE_ZONE_POLYGONS:"api/zone/edit-zones-ploygons",

  GET_ALL_TIME_SLOTE: "api/zone-working-hours/list",
  CREATE_TIME_SLOTE: "api/zone-working-hours/create",
  EDIT_TIME_SLOTE: "api/zone-working-hours/edit",
  DELETE_TIME_SLOTE: "api/zone-working-hours/delete-date-slot",

  GET_ALL_HOLIDAYS: "api/zone-holiday/list",
  CREATE_HOLIDAY: "api/zone-holiday/create",
  EDIT_HOLIDAY: "api/zone-holiday/edit",
  UPDATE_HOLIDAY_STATUS: "api/zone-holiday/update-status",

  CREATE_DATE_SLOT: "api/zone-working-hours/add-date-slot",
  EDIT_DATE_SLOT: "api/zone-working-hours/update-date-slot",
  UPDATE_DATE_SLOT: "api/zone-working-hours/update-slots",
};

//SYSTEM SETTING
export const SYSTEM_SETTING = {
  GET_SETTING_DETAIL: "api/setting/detail",
  UPDATE_SETTING: "api/setting/update",
};

//Manage QC Routes
export const MANAGE_MODIFIERES = {
  GET_ALL_MODIFIERS: "api/modifier/list",
  UPDATE_STATUS: "api/modifier/update-status",
  GET_ALL_VENDOR_LIST: "api/modifier/vendor-list",
  CREATE_MODIFIER: "api/modifier/create",
  EDIT_MODIFIER: "api/modifier/edit",
  GET_MODIFIER_DETAIL: "api/modifier/detail",
};

//Manage Product
export const MANAGE_PRODUCT = {
  GET_ALL_MODIFIER_LIST: "api/product/modifier-list",
  GET_MODIFIER_ITEMS: "api/product/modifier-item-list",
  GET_PACKAGE_SIZE: "api/product/packaging-type-list",
  GET_ITEM_SENSITIVITY: "api/product/item-sensitivity-list",
  CREATE_PRODUCT: "api/product/create",
  EDIT_PRODUCT: "api/product/edit",
  GET_ALL_PRODUCT: "api/product/list",
  GET_PRODUCT_DETAIL: "api/product/detail",
  UPDATE_STATUS: "api/product/update-status",
  UPLOAD_IMAGE: "api/product/add-images",
  UPDATE_FEATURE_STATUS: "api/product/update-feature-status",
};

export const TIME_SLOTE = {
  GET_ALL_TIME_SLOTE: "api/dropzone-and-branch-working-hours/list",
  CREATE_TIME_SLOTE: "api/dropzone-and-branch-working-hours/create",
  EDIT_TIME_SLOTE: "api/dropzone-and-branch-working-hours/edit",
  // DELETE_TIME_SLOTE: "api/zone-working-hours/delete-date-slot",
  CREATE_DATE_SLOT: "api/dropzone-and-branch-working-hours/add-date-slot",
  // EDIT_DATE_SLOT: "api/zone-working-hours/update-date-slot",
  UPDATE_DATE_SLOT: "api/dropzone-and-branch-working-hours/update-slots",
};

export const ORDERS = {
  GET_ALL_ORDER_LIST: "api/orders/list",
  GET_ORDER_DETAIL: "api/orders/detail",
  SEND_REQUEST_FOR_APPROVAL: "api/orders/send-to-customer-approval",
  CANCEL_ORDER: "api/orders/cancel-order",
  UPDATE_ORDER_STATUS: "api/orders/update-status",
  MOVED_TO_DELIVERD: "api/orders/move-to-delivered",
  ORDER_STATUS_COUNT: "api/orders/order-status-count",
  GET_ALL_BRANCH: "api/orders/get-all-branches",
  GET_ALL_BRANCH_FOR_BULK: "api/orders/get-all-branches-for-bulk",
  GET_ALL_ZONE: "api/orders/get-all-zones",
  ADD_IMAGES_FOR_QC: "api/orders/add-images-for-qc",
  SUBMIT_TO_QC: "api/orders/submit-to-qc",
  GET_ALL_QC: "api/orders/get-all-qc",
  ASSIGN_TO_QC: "api/orders/assign-to-qc",
  GET_ALL_DRIVER: "api/orders/driver-list",
  ASSIGN_TO_DRIVER: "api/orders/reassign-driver",
  REFUND_ORDER: "api/orders/refund-order",
  RESHEDULE_ORDER: "api/orders/reschedule-order",
  GET_SLOTS: "api/orders/get-slotes",
  GET_ALL_BRANCH_BY_VENDOR: "api/orders/get-all-branches-by-vendor",
  GET_ALL_PACKAGING_LIST: "api/orders/packaging-size-list",
  EDIT_ORDER: "api/orders/edit-order",
  GET_ALL_PRODUCT_LIST_BY_VENDOR: "api/orders/product-list",
  GET_ALL_PRODUCT_UOM_LIST: "api/orders/product-uom-list",
  GET_ALL_UOM_MODIFIRE_LIST: "api/orders/modifier-list",
  GET_ALL_CUSTOME_MODIFIRE_LIST: "api/orders/custom-question-modifier-list",
  ADD_CUSTOME_CAKE_IMAGE: "api/orders/add-custom-cake-images",
  DOWNLOAD_INVOICE: "api/orders/download-invoice",
  GET_ALL_DRIVER_LIST: "api/orders/get-all-drivers",
  GET_ALL_DROPZONE: "api/orders/get-all-dropzones",
  // RESEND_ORDER_OTP: "api/customer/resend-order-otp",
  // ORDER_OTP_VERIFY: "api/customer/order-otp-verify",
  SEND_OTP: "api/send-otp",
  VERIFY_OTP: "api/verify-otp",
  DELAY_MESSAGE_SEND: "api/orders/send-delay-message",
  ADD_DEDUCTION: "api/orders/add-deduction",
  ASSIGN_LOCKER_TO_ORDER: "api/orders/assign-locker",
  OPEN_LOCKER: "api/orders/open-locker",
  LOCKER_ITEM_DELIVERED: "api/orders/mark-delivered",
  REACTIVATE_CANCELLED_ORDER: "api/orders/reactivate-cancelled-order",
  BULK_UPLOAD: "api/orders/bulk-upload",
  CHECK_ADDRESS_IN_ZONE: "api/orders/address-in-zone",
  SET_PREFERRED_LANGUAGE: "api/orders/set-preferred-language",
};

//Manage Report
export const MANAGE_REPORT = {
  GET_ALL_PAYMENTS_REPORT_BY_ZONE: "api/report/zone",
  GET_ALL_PAYMENTS_REPORT_BY_ZONE_ORDERS: "api/report/zone-orders",
  GET_ALL_PAYMENTS_REPORT_BY_ITEM: "api/report/item",
  GET_ALL_PAYMENTS_REPORT_BY_ITEM_ORDERS: "api/report/get-item-orders",
  GET_ALL_PAYMENTS_REPORT_BY_CUSTOMER: "api/report/customer",
  GET_ALL_PAYMENTS_REPORT_BY_CUSTOMER_ORDERS: "api/report/get-customer-orders",
  GET_ALL_PAYMENTS_REPORT_BY_VENDOR: "api/report/vendor",
  GET_ALL_PAYMENTS_REPORT_BY_VENDOR_ORDERS: "api/report/get-vendor-orders",
  GET_ALL_PAYMENTS_REPORT_BY_DRIVER: "api/report/driver",
  GET_ALL_PAYMENTS_REPORT_BY_DRIVER_ORDERS: "api/report/get-driver-orders",
  GET_ALL_PAYMENTS_REPORT_ORDER_TYPE: "api/report/order-type",
  GET_ALL_PAYMENTS_REPORT_BY_ORDER_TYPE_ORDERS: "api/report/get-order-type",
  GET_ALL_PAYMENTS_REPORT_BY_DELIVERY_MODE: "api/report/delivery-mode",
  GET_ALL_PAYMENTS_REPORT_BY_DELIVERY_MODE_ORDERS: "api/report/get-delivery-mode",
  GET_ALL_PAYMENTS_REPORT_BY_TIME_SLOT: "api/report/time-slot",
  GET_ALL_PAYMENTS_REPORT_BY_TIME_SLOT_ORDERS: "api/report/get-time-slot",
  GET_ALL_PAYMENTS_REPORT: "api/report/payments",
  GET_ALL_COUPON_REPORT: "api/report/coupon",
  GET_ALL_ORDERS_OF_COUPON: "api/report/coupon-orders",
  GET_ALL_LATE_ORDERS: "api/report/late-orders",
  GET_ALL_REFUND_ORDERS: "api/report/refund-orders",
  GET_ALL_CANCELLED_ORDERS: "api/report/cancelled-orders",
  GET_ALL_SALES_DETAILS_REPORT: "api/report/sales-details-orders",
  GET_WALLET_TRANSACTIONS_REPORT: "api/report/wallet-report",
  GET_DRIVER_REPORT: "api/report/driver-reports",
};

//Manage Roles and permissions Routes
export const MANAGE_ROLES_AND_PERMIISION = {
  GET_ALL: "api/role-permission/list",
  UPDATE_STATUS: "api/role-permission/update-status",
  GET_DETAIL: "api/role-permission/details",
  CREATE: "api/role-permission/create",
  EDIT: "api/role-permission/edit",
};

//Manage Subadmin Routes
export const MANAGE_SUBADMIN = {
  GET_ALL_ROLE: "api/subadmin/get-roles",
  GET_ALL: "api/subadmin/list",
  UPDATE_STATUS: "api/subadmin/update-status",
  GET_DETAIL: "api/subadmin/details",
  CREATE: "api/subadmin/create",
  EDIT: "api/subadmin/edit",
  GET_ALL_VENDOR: "api/subadmin/get-vendors",
  GET_ALL_BRNACH: "api/subadmin/get-branches",
  GET_ALL_DROPZONES: "api/subadmin/get-dropzones",
};

//MANAGE COUPON
export const MANAGE_COUPON = {
  GET_ALL_COUPON: "api/coupon/list",
  UPDATE_STATUS: "api/coupon/update-status",
  GET_COUPON_DETAIL: "api/coupon/detail",
  CREATE_COUPON: "api/coupon/create",
  EDIT_COUPON: "api/coupon/edit",
  VENDOR_LIST: "api/coupon/vendor-list",
};

// MANAGE CMS
export const MANAGE_CMS = {
  GET_CMS: "api/admin/cms/get-cms",
  ADD_CMS: "api/admin/cms/add-cms",
  UPDATE_CMS: "api/cms/update-cms",
  DELETE_CMS: "api/cms/delete-cms",
  GET_VENDOR_ENQUIRY_LIST: "api/vendor-enquiry/list",
};

export const MANAGE_SUBSCRIPTION = {
  ADD_SUBSCRIPTION: "api/subscriptions/create-subscription",
  GET_ALL_SUBSCRIPTIONS: "api/subscriptions/get-subscriptions",
  UPDATE_SUBSCRIPTION_STATUS: "api/subscriptions/update-status",
  EDIT_SUBSCRIPTION : "api/subscriptions/edit-subscription",
  GET_SUBSCRIPTION_DETAIL: "api/subscriptions/subscription-details",
}

export const MANAGE_CANNED_ORDER = {
  GET_ALL_ORDER_LIST: "api/admin/canned-order/list",
  GET_ORDER_DETAIL: "api/admin/canned-order/details",
  UPDATE_STATUS: "api/admin/canned-order/update-status",
  ORDER_STATUS_COUNT: "api/admin/canned-order/order-status-count",
};
